import { Filters } from '@/types';

export namespace Notifications {
  export enum Pages {
    NOTIFICATIONS = 'notifications',
    SETTINGS = 'settings',
    NOTIFICATIONS_SETTINGS = 'notifications_settings',
  }

  export enum Types {
    NOTIFICATION = 'notification',
    DIGEST = 'digest',
    NOT_NOTIFICATION = 'not_notification',
  }

  export enum Periods {
    DAILY = 'daily',
    WEEKLY = 'weekly',
  }

  export enum Selections {
    ALL_CLIENT = 'all_client',
    SELECTED_CLIENT = 'selected_client',
  }

  export enum Structures {
    CLIENT = 'client',
    TYPE = 'type',
    COMBINED = 'combined'
  }

  export enum TypeEvents {
    ALL_EVENT = 'all_event',
    SELECTED_EVENT = 'selected_event',
  }

  export enum CriticalEvents {
    RECOMMENDED_EVENT = 'recommended_event',
    SELECTED_EVENT = 'selected_event',
  }

  export interface ClientSetting {
    setting: {
      id: number,
      client_notification_setting_type_slug: Types,
      client_notification_setting_period_slug: Periods,
      client_notification_setting_structure_slug: Structures,
      client_notification_setting_selection_slug: Selections,
      client_notification_setting_type_event_slug: TypeEvents,
      client_notification_setting_critical_event_slug: CriticalEvents,
      dispatch_to: string | null,
      weekdays: [],
      client_marks: [],
      client_statuses: [],
      cities: [],
      client_event_types: [],
      critical_client_event_types: [],
      is_critical: boolean,
    },
    selects: {
      types: [],
      periods: [],
      selections: [],
      structures: [],
      type_events: [],
      critical_events: [],
      marks: [],
      client_statuses: [],
      cities: [],
      client_event_types: [],
      weekdays: [],
    },
  }

  export interface SettingsTab {
    title: string;
    component: string;
  }

  export interface Section {
    id: number,
    name: string,
    slug: string,
  }

  export interface AdditionalData {
    [key: string]: unknown,
    url: string,
    type: string,
  }

  export interface Notification {
    [key: string]: unknown,
    id: number,
    section: Section,
    title: string,
    is_read: boolean,
    reference_id: string,
    additional_data: AdditionalData,
    date: string,
    time: string,
    is_popup_required?: boolean,
  }

  export interface NotificationCols {
    text: string,
    align?: string,
    value: string,
    sortable?: boolean,
    is_visible?: boolean,
    filterable?: boolean,
  }

  export interface UserNotifications {
    [key: string]: unknown,
    id?: number | null,
    is_allowed?: boolean,
    name?: string | null,
    slug?: string | null,
  }

  export interface UserUnreadEntities {
    [key: string]: unknown,
    page_id?: number | null,
    is_allowed?: boolean,
    page_name?: string | null,
    page_slug?: string | null,
  }

  export interface ClientEventType {
    id: number,
    name: string,
    client_event_channel_blocks: Notifications.ClientEventChannelBlock[]
  }

  export interface ClientEventChannel {
    id: number,
    name: string,
    slug: string,
  }

  export interface ClientEventChannelBlock {
    id: number,
    client_event_type_id: number,
    client_event_channel_id: number,
  }

}

export interface NotificationsFilters extends Filters {
  [key: string]: unknown,
  not_read_only: boolean,
  sections: Notifications.Section[] | null,
}
